type QueryMap = Record<string, unknown>;

/**
 * クエリをもとに計測用のパラメータ値を生成する。
 * @param {QueryMap} query
 * @returns
 */
export const convertQuery = (query: QueryMap) => {
  // query [key]__[value]に変換
  let newQuery = '';

  Object.keys(query).forEach((key, idx) => {
    let value = query[key];
    if (value) {
      if (Array.isArray(value)) value = value.join();
      if (idx > 0) {
        newQuery += '_';
      }
      newQuery += `${key}__${value}`;
    }
  });

  return `${newQuery}`;
};
